// Adds visibility of which version number it is currently being used
// eslint-disable-next-line no-underscore-dangle
window.__mi9__ = {
  buildNumber: BUILD_NUMBER,
  buildDatetime: BUILD_DATETIME,
};
